import { render, staticRenderFns } from "./NonFranchiseCourseView.vue?vue&type=template&id=3629fc32"
import script from "./NonFranchiseCourseView.vue?vue&type=script&lang=js"
export * from "./NonFranchiseCourseView.vue?vue&type=script&lang=js"
import style0 from "./NonFranchiseCourseView.vue?vue&type=style&index=0&id=3629fc32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports